var React = require('react');

function StarF (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 1.75l3.54 10.89H31l-9.27 6.72 3.54 10.89L16 23.52l-9.27 6.73 3.54-10.89L1 12.64h11.46z"}));
}

StarF.defaultProps = {"viewBox":"0 0 32 32","fillRule":"evenodd","id":"ki-star-f"};

module.exports = StarF;

StarF.default = StarF;
